import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useResource(resource) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      setItems(await api.list(resource));
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [resource]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { items, loading, refetch };
}
